import * as ko from 'knockout';
import * as _ from "underscore";

// Helpers
import "selectTwoBindingConfig";
import "knockoutCustomBindings";

// Models
import { AgreementSelectionBase } from "Content/ts/Shared/AgreementSelector/AgreementSelectionBase";
import { SelectTwoWithChildren } from "Content/ts/Models/Shared/SelectTwo/selectTwoModels";

// Interfaces
import { IAgreementSelectorParams } from "Content/ts/Models/Shared/AgreementSelector/IAgreementSelectorParams";

export default class AgreementSelector extends AgreementSelectionBase {
    availableMemberships: KnockoutObservableArray<SelectTwoWithChildren>;

    constructor(params: IAgreementSelectorParams) {
        super(params);

        this.availableMemberships = params.Memberships;
    };
}

const componentName = "single-agreement-selection";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: AgreementSelector,
    template: { require: `text!/Themes/Default/Content/ts/Shared/AgreementSelector/${componentName}.html` }
});